export enum STATUS_DATA_EXPORT {
  PENDING = 'pending',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  FAILED = 'failed',
  SCRUBBED = 'scrubbed',
}
